export const CATEGORY_TYPES = {
  EXERCISE: 'exercise',
  MATERIAL: 'education',
  QUESTIONNAIRE: 'questionnaire'
};
